import script from "./MutatedEditPatient.vue?vue&type=script&lang=ts&setup=true"
export * from "./MutatedEditPatient.vue?vue&type=script&lang=ts&setup=true"

import "./MutatedEditPatient.vue?vue&type=style&index=0&id=57603a84&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57603a84"]])

export default __exports__